import { Redirect, router } from 'expo-router';
import {
    BodyMediumRegular,
    Button,
    ButtonSize,
    ButtonVariant,
    CheckCircleIcon,
    H5Regular,
    Icon,
    ScreenContainer,
    YStack,
} from 'smoothie';

// Throwaway POC screen: confirms the upgrade completed.
export default function UpgradeSuccessPage() {
    if (
        process.env.EXPO_PUBLIC_FRUITFUL_ENV !== 'local' &&
        process.env.EXPO_PUBLIC_FRUITFUL_ENV !== 'sandbox' &&
        process.env.EXPO_PUBLIC_FRUITFUL_ENV !== 'staging'
    ) {
        return <Redirect href="/" />;
    }

    return (
        <ScreenContainer title="Premium Membership">
            <YStack gap={16} alignItems="center" paddingTop={48}>
                <Icon icon={CheckCircleIcon} size={48} color="$green1200" />
                <H5Regular>You&apos;re on Premium</H5Regular>
                <BodyMediumRegular color="$gray1000" textAlign="center">
                    Your upgrade was successful. It may take a moment for every
                    screen to reflect your new membership.
                </BodyMediumRegular>
                <Button
                    text="Done"
                    variant={ButtonVariant.PRIMARY}
                    size={ButtonSize.LARGE}
                    onPress={() => {
                        router.dismissAll();
                        router.replace('/dev');
                    }}
                />
            </YStack>
        </ScreenContainer>
    );
}
